import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function PaymentsPanel() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/admin/payments").then((r) => setList(r.data)).catch(() => setList([])); }, []);
  if (!list) return <p className="text-sm text-slate-500">Loading…</p>;
  const total = list.reduce((a, p) => a + p.amount, 0);
  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/60" data-testid="payments-panel">
      <div className="flex items-center justify-between px-5 py-4 border-b border-slate-800">
        <p className="font-heading font-bold">Payments</p>
        <p className="text-sm text-slate-400" data-testid="payments-total">{list.length} payments · <b className="text-amber-300">₹{total.toLocaleString("en-IN")}</b></p>
      </div>
      {!list.length ? <p className="p-8 text-center text-sm text-slate-500">No payments yet. They appear here when jewellers pay online.</p> : (
        <table className="w-full text-xs">
          <thead><tr className="text-left text-[10px] font-mono uppercase tracking-wider text-slate-500 border-b border-slate-800">
            <th className="px-5 py-3">Date</th><th className="px-4 py-3">Store</th><th className="px-4 py-3">Plan</th><th className="px-4 py-3">Type</th><th className="px-4 py-3">Amount</th><th className="px-4 py-3">Razorpay ID</th>
          </tr></thead>
          <tbody>{list.map((p, i) => (
            <tr key={p.id} className="border-b border-slate-800/60" data-testid={`payment-row-${i}`}>
              <td className="px-5 py-2.5">{new Date(p.created_at).toLocaleDateString()}</td><td className="px-4 py-2.5 font-mono">{p.email}</td>
              <td className="px-4 py-2.5">{p.plan_name}</td><td className="px-4 py-2.5 capitalize text-slate-400">{p.kind}</td>
              <td className="px-4 py-2.5 font-mono text-amber-300">₹{p.amount.toLocaleString("en-IN")}</td><td className="px-4 py-2.5 font-mono text-slate-500">{p.payment_id}</td>
            </tr>
          ))}</tbody>
        </table>
      )}
    </section>
  );
}
